<template>
<m-pageframe
    :title="profile.organization_account.label + ' Settings'"
    :color="pageframe_color"
>
<v-container 
    style="padding-left: 25px; padding-right: 25px;"
    fluid
>

<v-expansion-panels
    v-model="open_panel"
>
    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">General Settings</v-expansion-panel-header>
        <v-expansion-panel-content>
            <m-settings-organization-general
                :profile="profile"
                v-on:upsert-organization-account="upsertOrganizationAccount"
                v-on:reload="reloadProfile"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">RedChirp Users</v-expansion-panel-header>
        <v-expansion-panel-content>
            <m-settings-organization-team-members
                :profile="profile"
                v-on:patch-employee="patchEmployee"
                v-on:add-team-member="addTeamMember"
                v-on:set-password="onSetPassword"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Teams</v-expansion-panel-header>
        <v-expansion-panel-content>
            <m-settings-organization-groups
                :profile="profile"
                v-on:post-group="onPostGroup"
                v-on:delete-group="onDeleteGroup"
                v-on:move-group="onMoveGroup"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">RedChirp Phone Numbers</v-expansion-panel-header>
        <v-expansion-panel-content>
            <m-settings-organization-phone-numbers
                :profile="profile"
                v-on:patch-endpoint="patchEndpoint"
                v-on:show-phone-number-dialog="showAddPhoneNumberDialog"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Domain Names</v-expansion-panel-header>
        <v-expansion-panel-content>
            <m-settings-organization-domains
                :profile="profile"
                v-on:delete-domain="deleteDomain"
                v-on:domain-added="reloadProfile()"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Inboxes</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-btn
                color="primary"
                v-on:click="onClickInboxes"
            >
                View / Edit Inboxes...
            </v-btn>
        </v-expansion-panel-content>
    </v-expansion-panel>


    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Webchat URL(s)</v-expansion-panel-header>
        <v-expansion-panel-content>
            <m-settings-organization-inbox-urls
                :profile="profile"
                v-on:update-urls="postInboxURLs($event)"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Webchat Widget</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-btn
                v-on:click="onClickWidgetSettings"
                color="primary"
            >
                View / Edit Webchat Widget Settings
            </v-btn>
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Payments</v-expansion-panel-header>
        <v-expansion-panel-content>
           <m-settings-organization-payment
                :profile="profile"
                v-on:upsert-organization-account="upsertOrganizationAccount"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Utilization</v-expansion-panel-header>
        <v-expansion-panel-content>
           <m-settings-organization-utilization
                :profile="profile"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Integrations</v-expansion-panel-header>
        <v-expansion-panel-content>
           <m-settings-organization-integrations
                :profile="profile"
                v-on:reload="reloadProfile"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Locations</v-expansion-panel-header>
        <v-expansion-panel-content>
           <m-settings-organization-locations
                :profile="profile"
                v-on:reload="reloadProfile"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Custom Keywords</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-btn
                color="primary"
                v-on:click="onClickKeywordAutoResponses"
            >
                View / Edit...
            </v-btn>
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">CTIA Keywords</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-btn
                color="primary"
                v-on:click="onClickCTIAKeywordAutoResponses"
            >
                View / Edit...
            </v-btn>
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Banner Branding</v-expansion-panel-header>
        <v-expansion-panel-content>
            <m-settings-organization-banner-branding
                :profile="profile"
                v-on:reload="reloadProfile"
            />
        </v-expansion-panel-content>
    </v-expansion-panel>

     <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Introductions</v-expansion-panel-header>
        <v-expansion-panel-content>
            <div
                style="text-align: right"
            >
                <v-btn
                    v-on:click="onClickEditIntroductionSettings"
                    color="primary"
                >
                    Edit Introduction Settings...
                </v-btn>
            </div>
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Branded Link Shortener</v-expansion-panel-header>
        <v-expansion-panel-content>
            <div
                    v-if="!profile.organization_account.provision_branded_link_shortener"
                    style="text-align: center"   
                >
                <p>Your organization's RedChirp plan does not included branded link shortening.</p>
                <p>contact us today to upgade!</p>

                <p
                    v-if="$rc.$state.isSystemsAdmin"
                >
                    <b>System Administrators:</b> access is controlled via the provision section on this page.
                </p>
            </div>

            <div
                style="text-align: right"
            >
                <v-btn
                    v-on:click="onClickBrandedLinkShortenerSettings"
                    color="primary"
                    v-if="profile.organization_account.provision_branded_link_shortener"
                >
                    Settings...
                </v-btn>
            </div>
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Tags</v-expansion-panel-header>
        <v-expansion-panel-content>
            <div
                style="text-align: right"
            >
                <v-btn
                    v-on:click="onClickEditRedChirpTags"
                    color="primary"
                >
                    View / Edit RedChirp Tags...
                </v-btn>
            </div>
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel
        v-if="can_write"
    >
        <v-expansion-panel-header class="bold_header">RedChirp Billing</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-btn
                color="primary"
                v-on:click="onClicnRedChirpBilling"
            >
                RedChirp Billing...
            </v-btn>
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Custom Forms</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-btn
                color="primary"
                v-on:click="onClickForms"
            >
                View / Edit Forms...
            </v-btn>
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel
        v-if="$rc.isCRMEnabledThatSupports('order')"
    >
        <v-expansion-panel-header class="bold_header">Order Attribution</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-btn
                color="primary"
                v-on:click="onClickOrderAttribution"
            >
                View / Edit Order Attribution Settings...
            </v-btn>
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">API Keys</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-btn
                color="primary"
                v-on:click="onClickAPIKeys"
            >
                View / Edit API Keys...
            </v-btn>
        </v-expansion-panel-content>
    </v-expansion-panel>

    <v-expansion-panel>
        <v-expansion-panel-header class="bold_header">Fonts</v-expansion-panel-header>
        <v-expansion-panel-content>
            <v-btn
                color="primary"
                v-on:click="onClickFonts"
            >
                View / Edit Fonts...
            </v-btn>
        </v-expansion-panel-content>
    </v-expansion-panel>


    

</v-expansion-panels>

<m-settings-organization-add-phone-number
    ref="add_phone_number"
    v-on:ok="reloadProfile()"
/>

<v-overlay
    
    opacity="0.3"
    :value="show_loading"
    z-index="10"
>
     <v-progress-circular
      :size="70"
      :width="7"
      color="primary"
      indeterminate
    ></v-progress-circular>
</v-overlay>

</v-container>
</m-pageframe>
</template>

<script>
const E164 = require("@/js/E164.js");
const _ = require('lodash');

const empty_profile = {
    organization_id: '00000000-0000-0000-0000-000000000000',

    organization_account: {
        "organization_id": '00000000-0000-0000-0000-000000000000',
        "label": ""
    },

    employees: [],
    endpoints: [],
    actor_permissions: {
        "can_read": true,
        "can_write": false,
        "is_system_admin": false
    }
};

export default {
    data() {
        return {
            tab: 0,
            profile: empty_profile,
            pixel_code: '',
            show_loading: true,
            open_panel: null,
        }
    },

    mounted () 
    {
        this.open_panel = this.$rc.getOpenPanel(this.$route);

        this.reloadProfile();
    },

    methods: {

        reloadProfile()
        {
            this.$rc.getOrganizationProfile(this.$route.params.organization_id, this.onReceiveProfile);
        },

        onReceiveProfile(profile, pixel_code) 
        {
            this.profile = profile;
            this.pixel_code = pixel_code;
            this.$forceUpdate();
            this.show_loading = false;
        },

        showAction()
        {

        },

        upsertOrganizationAccount(new_organization_account)
        {
            this.show_loading = true;
            this.$forceUpdate();

            this.$rc.showSpinner();
            
            this.$rc.rest(
                'PUT: /api/v1/organizations/organization-account',
            
                new_organization_account,
            
                (data) => {
                    this.$rc.hideSpinner();
                    this.reloadProfile();
                },
            
                () => {
                    this.$rc.hideSpinner();
                    this.$rc.alert('Error','Unable to save changes to organization');
                },
            );
        },

        patchEmployee(changes)
        {
            this.$rc.rest({
                'spinner': true,
                'endpoint': 'PATCH: /api/v1/employees',
            
                'params' : changes,
            
                'on_success': (data) => {
                        this.reloadProfile();
                    },
            
                'on_error': 'Unable to update employee account',
            });
        },

        patchEndpoint(changes)
        {
            this.show_loading = true;
            this.$forceUpdate();
            this.$rc.patchOrganizationEndpoint(changes.endpoint, changes, () => this.reloadProfile() );
        },

        addTeamMember(new_team_member_data)
        {
            this.show_loading = true;
            this.$forceUpdate();
            this.$rc.createEmployee(
                new_team_member_data, 
                () => {
                    this.afterAddTeamMember(new_team_member_data);
                },
                (message) => { 
                    this.show_loading = false;
                    alert(message) 
                } 
            );
        },

        afterAddTeamMember(new_team_member_data)
        {
            this.reloadProfile();
            
            if ( new_team_member_data.team_member_phone_number != 'new_number' )
            {
                return;
            }

            this.startOrderPhoneNumberForEmployee(new_team_member_data.employee_id);
        },

        showAddPhoneNumberDialog()
        {
            this.$refs['add_phone_number'].showDialog(this.profile.organization_id, this.profile.actor_permissions.is_system_admin, null);
        },

        startOrderPhoneNumberForEmployee(employee_id)
        {
            this.$refs['add_phone_number'].showDialog(this.profile.organization_id, this.profile.actor_permissions.is_system_admin, employee_id);
        },

        onSetPassword(password_data)
        {
            this.$rc.setPassword(password_data, () => alert('Password changed'), (message) => alert(message));
        },

        deleteDomain(domain)
        {
            this.$rc.deleteDomain(domain, () => this.reloadProfile(), () => alert('Unable to delete domain '+domain.domain) );
        },

      

        onPostGroup(group)
        {
            this.$rc.postEmployeeGroup(group, () => this.reloadProfile(), () => alert('Unable to edit group'));
        },

        onDeleteGroup(group)
        {
            this.$rc.deleteEmployeeGroup(group.organization_id, group.employee_group_id, () => this.reloadProfile(), () => alert('Unable to edit group'));
        },

        onMoveGroup(move_obj)
        {
            this.$rc.moveEmployeeGroup(move_obj.organization_id, move_obj.employee_group_id, move_obj.direction, () => this.reloadProfile(), () => alert('Unable to move group'));
        },

        onClickKeywordAutoResponses()
        {
            this.$router.push({
                    'name': 'settings-organization-keyword-auto-responses',
                    'params' : {
                        'organization_id' : this.$route.params.organization_id,
                    },
                });
        },

        onClickCTIAKeywordAutoResponses()
        {
            this.$router.push({
                    'name': 'settings-organization-ctia-keyword-auto-responses',
                    'params' : {
                        'organization_id' : this.$route.params.organization_id,
                    },
                });
        },

    

        postInboxURLs(inbox_urls)
        {
            this.show_loading = true;

            let organization_id = this.profile.organization_account.organization_id;
            
            this.$rc.postInboxURLs(
                organization_id,
                inbox_urls,

                (profile) => {
                    this.onReceiveProfile(profile)
                },

                () => {
                    alert('Unable to modify inbox urls');
                }
            )
        },

        onClickInboxes()
        {
            this.$router.push({
                'name': 'edit-inboxes',
                'params' : {
                    'organization_id': this.$route.params.organization_id
                }
            });
        },

        onClickEditIntroductionSettings()
        {
            this.$router.push({
                'name': 'settings-organization-introductions',
                'params' : {
                    'organization_id': this.$route.params.organization_id
                }
            });
        },

        onClickBrandedLinkShortenerSettings()
        {
            this.$router.push({
                'name': 'settings-organization-branded-link-shortener',
                'params' : {
                    'organization_id': this.$route.params.organization_id
                }
            });
        },

        onClickEditRedChirpTags()
        {
            this.$router.push({
                'name': 'settings-organization-tags',
                'params' : {
                    'organization_id': this.$route.params.organization_id
                }
            });
        },

        onClicnRedChirpBilling()
        {
            this.$router.push({
                'name': 'organization-redchirp-billing-settings',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                }
            });
        },

        onClickForms()
        {
            this.$router.push({
                'name': 'search-forms',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                }
            });
        },

        onClickOrderAttribution()
        {
             this.$router.push({
                'name': 'settings-organization-order-attribution',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                }
            });
        },

        onClickAPIKeys()
        {
            this.$router.push({
                'name': 'settings-organization-api-keys',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                }
            });
        },

        onClickFonts()
        {
            this.$router.push({
                'name': 'settings-organization-fonts',
                'params' : {
                    'organization_id': this.$route.params.organization_id,
                }
            });
        },

        onClickWidgetSettings()
        {
            this.$router.push({
                'name': 'settings-organization-widget',
                'params' : {
                      'organization_id': this.$route.params.organization_id,  
                }
            });  
        },

        onClickIntegrationSyncHistory(settings_id)
        {
            this.$router.push({
                'name': 'integration-sync-history',
                'params' : {
                    'settings_id': settings_id,
                }
            });
        },
    },

    computed: {

        can_write() {
            return this.profile.actor_permissions.can_write; 
        },

        pageframe_color() {
            if ( this.$route.params.organization_id == this.$rc.$state.organization_id )
                return '#F24653';
        
            return '#5D647C';
        },
    },
}
</script>

<style lang="scss" scoped>
.v-card__text, .v-card__title {
  word-break: normal; /* maybe !important  */
}

.bold_header
{
    font-size: 20px; 
    font-weight: bold;
}

</style>